<div class="blackout-date-dropdown" [attr.data-testid]="testIdPrefix">
  <div class="blackout-dropdown-selects">
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="selectedMonth"
        (ngModelChange)="onPartChange()"
        [attr.data-testid]="testIdPrefix + '-month'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'month'"
      >
        <option *ngIf="allowEmpty" [ngValue]="''">Month</option>
        <option *ngFor="let month of monthOptions" [ngValue]="month.value">{{ month.label }}</option>
      </select>
    </div>
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="selectedDay"
        (ngModelChange)="onPartChange()"
        [attr.data-testid]="testIdPrefix + '-day'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'day'"
      >
        <option *ngIf="allowEmpty" [ngValue]="''">Day</option>
        <option *ngFor="let day of dayOptions" [ngValue]="day">{{ day }}</option>
      </select>
    </div>
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="selectedYear"
        (ngModelChange)="onPartChange()"
        [attr.data-testid]="testIdPrefix + '-year'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'year'"
      >
        <option *ngIf="allowEmpty" [ngValue]="''">Year</option>
        <option *ngFor="let year of yearOptions" [ngValue]="year">{{ year }}</option>
      </select>
    </div>
  </div>
  <p class="blackout-date-written" *ngIf="formatDateWritten(value)">
    {{ formatDateWritten(value) }}
  </p>
</div>
